import React, { useState, useEffect } from 'react';
import { displayLoader } from '../utils';


const GameEvents = (props) => {
    const { 
        events = null,
        ...restProps 
    } = props;
    const [ isLoaded, setLoaded ] = useState(false);
    const [ hasNoResults, setNoResults ] = useState(false);

    useEffect( () => {
        if ( events instanceof Array ) {
            setLoaded(true);
            if ( !events.length ) setNoResults(true);
        }
    }, [events]);

    let awayGoals = 0;
    let homeGoals = 0;
    let awayPenalties = 0;
    let homePenalties = 0;

    // Return the loader if we don't have any data yet
    if ( !isLoaded ) return displayLoader('acaLoader--main');

    // If it's loaded but there's no results, display a message
    if ( hasNoResults ) return ( <div className="acaSmallNote" style={{textAlign: 'center'}}>No events were tracked for this match.</div> );

    return (
        <div className="gameEvents">
            { events.map( (event, i) => {
                let itemType = "event";
                let isHome = event.homeTeam;
                let type = event.eventType.fcdName.toLowerCase();
                let eventName = event.eventType.name;
                let time = event.displayMinute;
                let title, extra = "";

                switch (event.eventType.fcdName) {
                    case 'START':
                        itemType = "stage";
                        if ( event.matchPhase.fcdName == "FIRST_HALF" ) {
                            title = "Kick Off";
                        } else {
                            return;
                        }
                        break;
                    case 'END':
                    case 'FULL_TIME':
                        itemType = "stage";
                        if ( event.matchPhase.fcdName == 'PEN' ) {
                            title = `${event.matchPhase.name}: ${homePenalties}-${awayPenalties}`;
                        } else {
                            title = `${event.matchPhase.name}: ${homeGoals}-${awayGoals}`;
                        }
                        
                        break;
                    case 'SUBSTITUTION':
                        title = `IN: ${event.player.shortName}`;
                        extra = `OUT: ${event.player2.shortName}`;
                        break;
                    case 'GOAL':
                    case 'PENALTY':
                        if ( event.homeTeam ) { homeGoals++ } else { awayGoals++ };
                        title = event.player.shortName;
                        break;
                    case 'OWN_GOAL':
                        if ( event.homeTeam ) { awayGoals++ } else { homeGoals++ };
                        title = event.player.shortName;
                        break;
                    case 'PENALTY_GOAL':
                        if ( event.homeTeam ) { homePenalties++ } else { awayPenalties++ };
                        title = event.player.shortName;
                        break;
                    default:
                        title = "teamOfficial" in event ? event.teamOfficial.name : event.player.shortName;
                        extra = "teamOfficial" in event ? event.teamOfficial.role : '';
                        break;
                }

                if ( itemType == "stage" ) {
                    return (<GameStage key={i} title={title} />);
                } else {
                    return (<GameEvent key={i} home={isHome} type={type} time={time} eventName={eventName} title={title} extra={extra} />);
                }

            }) }
        </div>
    );
}

const GameStage = (props) => {
    const { 
        title = '',
        ...restProps 
    } = props;

    return (
        <div className="gameStage">{title}</div>
    );
}

const GameEvent = (props) => {
    const {
        home = false,
        type = '',
        time = '',
        title = '',
        eventName = '',
        extra = '',
        ...restProps
    } = props;

    const side = home ? 'home' : 'away';

    let classList = "gameEvent";
    classList += " gameEvent--" + side;
    classList += " gameEvent--" + type;


    return (
        <div className={classList}>
            <div className="gameEvent__icon"></div>
            <div className="gameEvent__infoBox">
                <div className="gameEvent__time">{time}</div>
                <div className="gameEvent__content">
                    { eventName ? (
                    <p className="gameEvent__eventName">{eventName}</p>
                    ) : '' }
                    <p className="gameEvent__title">{title}</p>
                    { extra ? (
                    <p className="gameEvent__extra">{extra}</p>
                    ) : '' }
                </div>
            </div>
        </div>
    );
}



/**
 * Export
 */
export { GameEvents };